import React, { useState } from 'react';
import {
  Box,
  Collapse,
  IconButton,
  Table as TableMui,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  Typography,
  Paper,
  TableContainer,
  useTheme,
  Chip,
  useMediaQuery,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Tooltip
} from '@mui/material';
import {
  KeyboardArrowDown,
  KeyboardArrowUp,
  ModeEditOutlined,
  DeleteForever,
  Delete,
  ReportOff,
  Analytics
} from '@mui/icons-material';
import { format } from 'date-fns';
import axios from 'axios';
import { toast } from 'react-toastify';
import EditDialog from './EditDialog';
import Minidialog from './Minidialog';
import TableHeader from './maintable';
import ClarityPopup from './ClarityPopup';
import UtmDetails from '../../common/UtmDetails';

const Row = ({ row = {}, handleDeleteUser }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [open, setOpen] = useState(false);
  const [editPopup, setEditPopup] = useState(false);
  const [miniDialogOpen, setMiniDialogOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [openClarity, setOpenClarity] = useState(false);
  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
  const [deleteProductId, setDeleteProductId] = useState(null);


  const handleClickOpen = (product, currentRow) => {
    if (product) {
      const customList = product?.custom_list?.[0];
      const fullFields = [
        'country',
        'industry',
        'person_location',
        'generic_email',
        'company_phone',
        'direct_dial'
      ];
      const mode = fullFields.some((field) => customList?.[field]) ? 'Full' : 'Minimal';
      setSelectedProduct(product);
      setSelectedRow(currentRow);
      if (mode === 'Minimal') {
        setMiniDialogOpen(true);
      } else {
        setEditPopup(true);
      }
    } else {
      setSelectedProduct(null);
      setSelectedRow(currentRow);
      setEditPopup(true);
    }
  };

  const handleClose = () => {
    setEditPopup(false);
    setMiniDialogOpen(false);
    setSelectedProduct(null);
    setSelectedRow(null);
  };

  const handleDeleteSubscribeProduct = async (subscribeProductId) => {
    try {
      await axios.delete('/api/v1/delete-register-user', {
        data: { subscribe_product_id: subscribeProductId }
      });
      toast.success('Subscribed product deleted successfully!');
      // Optionally, you can refresh the data or update the state here
      window.location.reload(); // Simple reload for now
    } catch (error) {
      toast.error('Failed to delete subscribed product!');
      console.error('Error:', error);
    }
  };


  const formatDate = (date) =>
    date ? format(new Date(date), 'dd MMM yyyy hh:mm a') : 'N/A';

  const getRoleChipProps = (role) => {
    if (!role) return {};
    switch (role.toLowerCase()) {
      case 'premium':
        return {
          label: role,
          size: 'small',
          variant: 'outlined',
          sx: {
            fontWeight: 600,
            textTransform: 'capitalize',
            color: theme.palette.success.dark,
            borderColor: theme.palette.success.dark
          }
        };
      case 'user':
        return {
          label: role,
          size: 'small',
          variant: 'outlined',
          sx: {
            fontWeight: 600,
            textTransform: 'capitalize',
            color: theme.palette.info.dark,
            borderColor: theme.palette.info.dark
          }
        };
      default:
        return {
          label: role,
          size: 'small',
          variant: 'outlined',
          sx: {
            fontWeight: 600,
            textTransform: 'capitalize'
          }
        };
    }
  };

  return (
    <>
      <TableRow
        hover
        sx={{
          '& > td': {
            px: { xs: 1, sm: 2, md: 3 },
            py: 1.5
          },
          '&:nth-of-type(even)': {
            backgroundColor: theme.palette.action.hover
          }
        }}
      >
        <TableCell>
          <IconButton
            size="small"
            onClick={() => setOpen(!open)}
            sx={{
              color: theme.palette.primary.main,
              backgroundColor: theme.palette.action.selected,
              '&:hover': {
                backgroundColor: theme.palette.action.hover
              }
            }}
          >
            {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row" sx={{ fontWeight: '500' }}>
          {row?.username || 'N/A'}
        </TableCell>
        <TableCell align="left">{row?.email || 'N/A'}</TableCell>
        <TableCell align="left">
          {row?.role ? <Chip {...getRoleChipProps(row.role)} /> : 'N/A'}
        </TableCell>
        <TableCell align="left">
          <UtmDetails row={row} />
        </TableCell>

        <TableCell align="right">{formatDate(row?.createdAt)}</TableCell>
        <TableCell align="right">
          <IconButton
            onClick={() => handleClickOpen(null, row)}
            sx={{
              color: theme.palette.primary.main,
              '&:hover': {
                backgroundColor: theme.palette.primary.light,
                color: "blue"
              }
            }}
          >
            <ModeEditOutlined fontSize="small" />
          </IconButton>
          <IconButton
            onClick={() => handleDeleteUser(row.id)}
            sx={{
              color: theme.palette.error.main,
              '&:hover': {
                backgroundColor: theme.palette.error.light,
                color: "red"
              }
            }}
          >
            <DeleteForever fontSize="small" />
          </IconButton>
          <IconButton
            onClick={() => setOpenClarity(true)}
            sx={{
              color: theme.palette.primary.main,
              "&:hover": {
                backgroundColor: theme.palette.primary.light,
                color: "blue",
              },
            }}
          >
            <Analytics fontSize="small" />
          </IconButton>
        </TableCell>
      </TableRow >

      <TableRow>
        <TableCell colSpan={10} sx={{ p: 0 }}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box
              sx={{
                m: { xs: 1, sm: 2, md: 3 },
                backgroundColor: theme.palette.background.paper,
                borderRadius: '8px',
                boxShadow: 3,
                overflowX: 'auto'
              }}
            >
              <Typography variant="subtitle1" sx={{ p: 2, fontWeight: '500' }}>
                Subscribe Products
              </Typography>
              <TableMui size="small" sx={{ minWidth: 650 }}>
                <TableHead>
                  <TableRow
                    sx={{
                      backgroundColor: theme.palette.primary.main,
                      '& th': {
                        color: theme.palette.common.white,
                        px: 2
                      }
                    }}
                  >
                    <TableCell>Event Name</TableCell>
                    <TableCell>Order Date</TableCell>
                    <TableCell align="right">Amount</TableCell>
                    <TableCell align="right">Exhibitors Count</TableCell>
                    <TableCell align='center'>Sub Product Type</TableCell>
                    <TableCell align="center">Created At</TableCell>
                    <TableCell align="right" sx={{ width: '120px' }}>
                      Action
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {row?.subscribedProducts?.length > 0 ? (
                    row.subscribedProducts.map((product, index) => (
                      <TableRow
                        key={product.id}
                        hover
                        sx={{
                          '& > td': {
                            px: 2,
                            py: 1.5,
                            borderBottom: `1px solid ${theme.palette.divider}`
                          }
                        }}
                      >
                        <TableCell>{product?.event_name || 'N/A'}</TableCell>
                        <TableCell>{formatDate(product?.order_date)}</TableCell>
                        <TableCell align="right">
                          {product?.amount_paid
                            ? `$${parseInt(product.amount_paid)}`
                            : 'N/A'}
                        </TableCell>
                        <TableCell align="center">
                          {product?.exhibitors_count || 'N/A'}
                        </TableCell>
                        {/* Displaying the sub product type */}
                        <TableCell align="center">
                          {(() => {
                            const customList = product?.custom_list?.[0];
                            if (!customList) return 'Full'; // Default to Full
                            const fullFields = [
                              'country',
                              'industry',
                              'person_location',
                              'generic_email',
                              'company_phone',
                              'direct_dial'
                            ];
                            const mode = fullFields.some((field) => customList[field]) ? 'Full' : 'Minimal';
                            return mode;
                          })()}
                        </TableCell>
                        {/* created at */}
                        <TableCell align="center">
                          {formatDate(product?.createdAt)}
                        </TableCell>
                        <TableCell align="right">
                          <IconButton
                            size="small"
                            onClick={() => handleClickOpen(product, row)}
                            sx={{
                              color: (() => {
                                const customList = product?.custom_list?.[0];
                                if (!customList) return theme.palette.primary.main;
                                const fullFields = [
                                  'country',
                                  'industry',
                                  'person_location',
                                  'generic_email',
                                  'company_phone',
                                  'direct_dial'
                                ];
                                const mode = fullFields.some((field) => customList[field]) ? 'Full' : 'Minimal';
                                return mode === 'Minimal' ? 'green' : theme.palette.primary.main;
                              })(),
                              '&:hover': {
                                backgroundColor: theme.palette.primary.light,
                                color: "blue"
                              }
                            }}
                          >
                            <ModeEditOutlined fontSize="small" />
                          </IconButton>
                          <IconButton
                            size="small"
                            onClick={() => {
                              setDeleteProductId(product.id);
                              setConfirmDeleteOpen(true);
                            }}
                            sx={{
                              color: theme.palette.error.main,
                              '&:hover': {
                                backgroundColor: theme.palette.error.light,
                                color: 'red'
                              }
                            }}
                          >
                            <Delete fontSize="small" />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={6} align="center" sx={{ p: 3 }}>
                        No Subscribed Products
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </TableMui>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>

      {
        editPopup && (
          <EditDialog
            open={editPopup}
            handleClose={handleClose}
            user={selectedRow}
            existingSubscribeProduct={selectedProduct}
          />
        )
      }
      {
        miniDialogOpen && (
          <Minidialog
            open={miniDialogOpen}
            handleClose={handleClose}
            onSubmit={(formData) => {
              console.log('Minidialog form submitted:', formData);
              // You can add further handling here if needed
              handleClose();
            }}
          />
        )
      }
      <ClarityPopup
        open={openClarity}
        onClose={() => setOpenClarity(false)}
        email={row.email} // 👈 row se email pass karenge
      />

      {/* 🔴 Confirm Delete Dialog */}
      <Dialog
        open={confirmDeleteOpen}
        onClose={() => setConfirmDeleteOpen(false)}
      >
        <DialogTitle>Confirm Delete</DialogTitle>

        <DialogContent>
          <Typography>
            Are you sure you want to delete this subscribed product?
            <br />
            <strong>This action cannot be undone.</strong>
          </Typography>
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setConfirmDeleteOpen(false)}>
            Cancel
          </Button>

          <Button
            color="error"
            variant="contained"
            onClick={() => {
              handleDeleteSubscribeProduct(deleteProductId);
              setConfirmDeleteOpen(false);
            }}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>

    </>
  );
};

const Table = ({ data = [], handleDeleteUser }) => {
  return (
    <Box sx={{ p: { xs: 1, sm: 2, md: 3 } }}>
      <TableContainer
        component={Paper}
        sx={{
          borderRadius: '12px',
          boxShadow: 3,
          overflowX: 'auto',
          mt: 3
        }}
      >
        <TableMui aria-label="collapsible table" sx={{ minWidth: 800 }}>
          <TableHeader />
          <TableBody>
            {data.map((row) => (
              <Row key={row.id} row={row} handleDeleteUser={handleDeleteUser} />
            ))}
          </TableBody>
        </TableMui>
      </TableContainer>
    </Box>
  );
};

export default Table;
